import React, { useContext } from 'react';
import { LanguageContext } from '../context/LanguageContext';
import { content } from '../data/content';

const Footer = () => {
  const { language } = useContext(LanguageContext);
  const { copyright, links } = content[language].footer;
  
  return (
    <footer className="bg-gray-800 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p>{copyright}</p>
          </div>
          <div className="flex space-x-6">
            <a href="#" className="hover:text-blue-300 transition-colors">{links.privacy}</a>
            <a href="#" className="hover:text-blue-300 transition-colors">{links.terms}</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
